var fibonacci = function fibonacci(n) {
  var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return n === 0 ? f : fibonacci(--n, s, f + s);
};

export default fibonacci;